// Normalize FastAPI error responses for toast display.
// FastAPI 422 returns {detail: [{loc, msg, type, ...}]} — passing that array
// directly to React (via toast) crashes with "Objects are not valid as a React child".
export function formatApiError(err, fallback = "Une erreur est survenue") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d))).join(", ") || fallback;
  }
  if (typeof detail === "object") return detail.msg || JSON.stringify(detail);
  return fallback;
}
